import { render, staticRenderFns } from "./comicCoverUpload.vue?vue&type=template&id=5c99a53e"
import script from "./comicCoverUpload.vue?vue&type=script&lang=js"
export * from "./comicCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./comicCoverUpload.vue?vue&type=style&index=0&id=5c99a53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports